import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { installMapillaryUrlRewriter } from './url-rewriter.js';
import { App } from './App.js';

// Must run before mapillary-js loads — rewrites graph/tiles/fbcdn URLs to
// our same-origin nginx proxies so the panorama works inside Discord.
installMapillaryUrlRewriter();

const container = document.getElementById('root');
if (!container) throw new Error('#root missing');
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
